<div class="row">
    <div class="col-12">
        <p class="text-center">Quase lá!</p>
        <p>Chegou a hora de assinarmos o contrato. Leia atentamente o documento de financiammento e coloque sua
            assinatura digital.</p>

        <textarea class="form-control" id="" rows="10">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima suscipit enim voluptate consequuntur aliquam, fugit explicabo rerum earum quo molestias cumque assumenda labore debitis nostrum a incidunt ratione consequatur tempora?
        </textarea>
    </div>
</div>

<div class="row">
    <div class="col-12">
        <p>Para assinar o contrato, digite o código de 6 dígitos que você irá receber em seu telefone.</p>
    </div>
</div>

<div class="row">
    <div class="col-6">
        <div class="form-group">
            <input type="tel" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" maxlength="6">
            <small id="emailHelp" class="form-text text-muted">Por favor, preencha o campo campo corretamente.</small>
        </div>
    </div>
    <div class="col-6 d-flex justify-content-center">
        <a href="#">Não recebi o código</a>
    </div>
</div>

<div class="row mt-3">
    <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-primary" (click)="next()">Assinar contrato e continuar</button>
    </div>
</div>